import Select from '@components/Select';
import { BRAZILIAN_STATES } from '@constants/brazil';

import { FieldRendererProps } from '../types';

const stateOptions = Object.entries(BRAZILIAN_STATES).map(([value, label]) => ({
  value,
  label: `${value} - ${label}`,
}));

const StateField = ({ field }: FieldRendererProps) => (
  <Select
    name={field.name}
    placeholder={field.placeholder || 'Selecione o estado'}
    options={stateOptions}
    required={field.is_required}
  />
);

export default StateField;
